module.exports = __webpack_public_path__ + "img/train-1.6388884c.jpg";